import { render, staticRenderFns } from "./ShippingOrderMap.vue?vue&type=template&id=2bf2ac8a"
import script from "./ShippingOrderMap.vue?vue&type=script&lang=js"
export * from "./ShippingOrderMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports